import { useLocation, useSearchParams } from "react-router-dom";

import { useEffect, useState } from "react";
import { Card, Result, Loading } from "../components";

export default function SharePage() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(location);
  const image = searchParams.get("image");
  const name = searchParams.get("name");
  const height = searchParams.get("height");
  const job = searchParams.get("job");
  const economy = searchParams.get("economy");
  const family = searchParams.get("family");
  const degree = searchParams.get("degree");
  const ability = {
    height: height,
    job: job,
    economy: economy,
    family: family,
    degree: degree,
  };

  const list = { image: image, name: name };
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1250);
  }, []);
  if (loading) {
    return <Loading />;
  }

  return (
    <div className="container">
      <Result image={image} name={name} share ability={ability}>
        <Card list={list} resultPage />
      </Result>
    </div>
  );
}
